import { Setting } from "../setting.model";

export class Partner {

  id!: number;
  name!: string;
  ordyxEmail?: string;
  type!: number;
  logoUrl?: string;

  crmId?: number;
  deskId!: string;
  groupId: string;
  stripeId?: string;

  buyRate!: number;
  buyType!: string;

  phone?: string;
  phoneSupport?: string;
  city?: string;
  street?: string;
  state!: string;
  postal?: string;
  country?: string;
  timeZone?: string;

  provisioned?: boolean;

  params!: Array<Setting>;

  created?: Date;
  updated?: Date;
  disabled?: boolean | Date;

  public load(data: any): Partner {
      Object.assign(this, data);

      this.params = new Array<Setting>();

      data?.params
          ?.forEach((p: Setting) => {
          this.params
              .push(new Setting().load(p))
        });

        return this;
  }

  public setValue(key: string,
            value: string): void {

      const existing = this.params?.find(s => s.name === key);

      if (existing){
        this.params = this.params
                          .map(u => u.name !== key ? u : new Setting().load({key, value}));
      } else {

        if (!this.params){
          this.params = new Array<Setting>();
        }

        this.params
            .push( new Setting().load({key, value}));
      }
  }

  public getValue(key: string): string | undefined {
      let param: Setting | undefined;

      if (this.params){
        param = this.params
                    .find(s => s.name === key);
      }

      return param?.value;
  }

  public hasParam(key: string): boolean {
      let has = false;

      if (this.params
              .find(s => s.name === key)){
        has = true;
      }

      return has;
  }

  public hasNoInstallFees(): boolean {
    return (this.hasPercentBuyRate() &&
            this.buyRate === 100) ||
           (this.hasFlatBuyRate() &&
            this.buyRate === 0);
  }

  public hasBuyRate(): boolean {
    return this.buyRate > 0;
  }

  public hasFlatBuyRate(): boolean {
    return this.buyType
               ?.toLocaleLowerCase() === 'flat';
  }

  public hasPercentBuyRate(): boolean {
    return this.buyType
               ?.toLocaleLowerCase() === 'percent';
  }
}
